import React from 'react'
import EditUserForm from './EditUserForm'
import { useParams } from 'react-router-dom'

const EditUser: React.FC = () => {

  const param = useParams();
  const {id} = param;
  return (  
        <EditUserForm userId={id} />
  )
}

export default EditUser